import { Button, Col, DatePicker, Form, Icon, Input, Modal, Row, Tag, Tooltip } from 'antd'
import useFetchSelect from '../../../elements/Hooks/useFetchSelect'
import useModalShow from '../../../elements/Hooks/useModalShow'
import { fullWidthFormItemLayout } from '../../../modules/FormItems'
import CustomSpin from '../../../elements/CustomSpin'
import FileSelect from '../../../elements/FileSelect'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import { get, isEmpty, uniq } from 'lodash'
import { defaultFormItemLayout, rules } from '../../../modules/FormItems'
import { dateVal, strVal } from '../../../modules/Utils'
import React, { Fragment, useState } from 'react'

function NewsletterForm(props) {
  const { newsletter, fetching, setMasterBody, setBaseBody } = props
  const { getFieldValue, getFieldDecorator, setFieldsValue } = props.form

  const { SelectData: MasterTemplateSelect } = useFetchSelect({ url: `/emailTemplate` })

  const company = (getFieldValue('company._id') || get(newsletter, 'company._id') || '').replace('members/', '')

  const { SelectData: BrandSelect } = useFetchSelect({
    url: `/brands/owner/${company}`,
    dependencyArray: [company],
    dontFetch: isEmpty(company),
  })

  const { SelectData: BaseTemplateSelect } = useFetchSelect({ url: `/templates/newsletter/base` })

  const { SelectData: EmailAddressSelect, selected: emailList = {} } = useFetchSelect({ url: `/emailAddress` })

  const { SelectData: SenderEmailSelect } = useFetchSelect({
    url: `/templates/newsletter/sender`,
    mapFunction: (c) => ({
      ...c,
      display: `${c.fn} - ${c.email}`,
    }),
  })

  const emails = (getFieldValue('emails') || strVal(newsletter, 'emails')).split(', ')

  const [showEmailEditor, setShowEmailEditor] = useState(false)

  const { visible, onShow, onCancel } = useModalShow()

  function onSubmit() {
    let newList = [...emails, ...emailList.emails]
    newList = uniq(newList)
    console.log(newList)
    setFieldsValue({ emails: newList.join(', ') })
    console.log('onSubmit', emailList)
    onCancel()
  }

  return (
    <CustomSpin spinning={fetching}>
      <Form>
        <FormSectionTitle title={'Preview Link'} link={`/newsletter/render/${newsletter._key}`} />
        <FormSectionTitle marginBottom={0} padding={0} title={'Newsletter Details'} />

        <Modal title="Add From Email List" visible={visible} onOk={onSubmit} onCancel={onCancel}>
          <Form.Item {...fullWidthFormItemLayout} label="Email List">
            <EmailAddressSelect keyAtr={'_id'} valueAtr={'name'} placeholder={'Email List'} value={emailList._id} />
          </Form.Item>
        </Modal>

        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Email Subject">
              {getFieldDecorator('subject', {
                initialValue: strVal(newsletter, 'subject'),
              })(<Input placeholder="Newsletter Subject" />)}
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Emails Address">
              {emails.map((i) => (
                <Tag color="#2db7f5">{i}</Tag>
              ))}
              <Tooltip title="Edit Email Address">
                <a onClick={() => setShowEmailEditor((e) => !e)}>
                  <Icon type="eye" />
                </a>
              </Tooltip>

              <Button className="ml-2" type="primary" icon="download" size={'small'} onClick={onShow}>
                Add List
              </Button>

              {getFieldDecorator('emails', {
                initialValue: strVal(newsletter, 'emails'),
                rules: [
                  {
                    required: true,
                    validator: async (rule, value) => {
                      const list = value.split(', ')
                      let allow = list.every((l) => {
                        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return re.test(String(l).toLowerCase())
                      })

                      if (!allow) {
                        throw new Error('Something wrong!')
                      }
                    },
                  },
                ],
              })(<Input hidden={!showEmailEditor} placeholder="Newsletter Subject" />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Master template">
              {getFieldDecorator('masterHTML.fn', {
                initialValue: get(newsletter, 'masterHTML.fn'),
              })(
                <MasterTemplateSelect
                  keyAtr={'fn'}
                  setSelected={setMasterBody}
                  valueAtr={'fn'}
                  placeholder={'Purchase Line'}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Base template">
              {getFieldDecorator('base', {
                initialValue: get(newsletter, 'base'),
              })(
                <BaseTemplateSelect
                  keyAtr={'fn'}
                  setSelected={setBaseBody}
                  valueAtr={'fn'}
                  placeholder={'Purchase Line'}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Sender Email">
              {getFieldDecorator('from', {
                initialValue: get(newsletter, 'from'),
              })(<SenderEmailSelect keyAtr={'email'} valueAtr={'display'} placeholder={'Purchase Line'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Company">
              {getFieldDecorator('company._id', {
                initialValue: get(newsletter, 'company._id'),
                rules: rules.input,
              })(<OrganisationsSelect style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Brand">
              {getFieldDecorator('brand', {
                initialValue: get(newsletter, 'brand'),
                rules: rules.input,
              })(<BrandSelect style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Send Date">
              {getFieldDecorator('sendDate', {
                initialValue: dateVal(newsletter, 'sendDate'),
              })(<DatePicker style={{ width: '100%' }} placeholder="Send Date" />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Image URL">
              {getFieldDecorator('parameters.image', {
                initialValue: get(newsletter, 'parameters.image'),
              })(<Input style={{ width: '100%' }} placeholder="Image url" />)}
            </Form.Item>
          </Col>
          {/*<FileSelect*/}
          {/*  {...{*/}
          {/*    doc: newsletter,*/}
          {/*    getFieldValue,*/}
          {/*    getFieldDecorator,*/}
          {/*    acc: 'files',*/}
          {/*    forceFetch: false,*/}
          {/*    label: 'Attachment Files',*/}
          {/*  }}*/}
          {/*/>*/}
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Reset Body">
              <Button type="primary" onClick={() => setBaseBody(get(newsletter, 'html'))}>
                Reset Body To saved
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </CustomSpin>
  )
}

export default Form.create()(NewsletterForm)
